import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { SAVE_UPDATE_APPLICATION, SUBMIT_COMPLETE_APP, FETCH_MASTER_URL, SAVE_UPDATE_APPLICATION_ENCRYPT, SUBMIT_COMPLETE_APP_ENCRYPT, FETCH_MASTER_URL_ENCRYPT, FETCH_MASTER_URL1 } from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';
import { SharedServiceService } from "./shared-service.service";

@Injectable({
  providedIn: "root"
})
export class CompleteApplicationService {
  personalData: any;
  professionalData:any;
  additionalData:any;
  tokenVal = sessionStorage.getItem('jwt');
  s24AccessToken = sessionStorage.getItem("s24_access_token");
  s24TokenExpiryTime = sessionStorage.getItem("s24_expiry_time");
  expandProfessional : boolean;
  officeStdCode: any;
  officeCity: any;
  submitClickedComp: any = false;
  addCardFeatureData: any;
  constructor(private http: HttpClient, private encryptDecService: EncrDecrService, private sharedService: SharedServiceService) {}

  saveUpdateApplication(requestBody){
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json'
      })
    };
    requestBody = SAVE_UPDATE_APPLICATION_ENCRYPT ? this.encryptDecService.set(requestBody): requestBody;
    return this.http.post(`${SAVE_UPDATE_APPLICATION}`, requestBody, httpOptions);
  }

  submitCompleteApp(requestBody){

    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
        }),
        observe: 'response'
      };
    }

    requestBody = SUBMIT_COMPLETE_APP_ENCRYPT ? this.encryptDecService.set(requestBody): requestBody;
    return this.http.post(`${SUBMIT_COMPLETE_APP}`, requestBody, httpOptions);
  }

  fetchMatserData(requestBody) {
    let httpOptions;
    if(this.sharedService.fromSwiftJourney){
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + sessionStorage.getItem('jwt_new'),
          withCredentials: 'true',
          'Content-Type': 'application/json',
          Cookie : sessionStorage.getItem('cookie_new')
        }),
        responseType : 'text'
      };
    }
    else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + this.tokenVal,
          withCredentials: 'true',
          'Content-Type': 'application/json',
        })
      };
    }
    
    if(this.sharedService.fromSwiftJourney) {
      console.log("new master data call from complete application service");
      requestBody = this.encryptDecService.set(requestBody);
      return this.http.post(`${FETCH_MASTER_URL1}`, requestBody, httpOptions);
    }
    else{
      console.log("old master data call from complete application service");
      requestBody = FETCH_MASTER_URL_ENCRYPT ? this.encryptDecService.set(requestBody):requestBody;
      return this.http.post(`${FETCH_MASTER_URL}`, requestBody, httpOptions);
    }
  }
}
